module.exports = __webpack_public_path__ + "img/65.ea16a700.jpg";